<template>
    <div class="offer-tooltip-info" v-if="offer?.id">
        <svg @click="modalTooltipInfoFun" class="offer-tooltip-info__icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.95 17.25H13.05V10.95H10.95V17.25ZM12 8.85C12.2975 8.85 12.547 8.7492 12.7486 8.5476C12.9502 8.346 13.0507 8.0968 13.05 7.8C13.05 7.5025 12.9492 7.2533 12.7476 7.0524C12.546 6.8515 12.2968 6.7507 12 6.75C11.7025 6.75 11.4533 6.8508 11.2524 7.0524C11.0515 7.254 10.9507 7.5032 10.95 7.8C10.95 8.0975 11.0508 8.34705 11.2524 8.54865C11.454 8.75025 11.7032 8.8507 12 8.85ZM12 22.5C10.5475 22.5 9.1825 22.2242 7.905 21.6726C6.6275 21.121 5.51625 20.3731 4.57125 19.4287C3.62625 18.4837 2.8783 17.3725 2.3274 16.095C1.7765 14.8175 1.5007 13.4525 1.5 12C1.5 10.5475 1.7758 9.1825 2.3274 7.905C2.879 6.6275 3.62695 5.51625 4.57125 4.57125C5.51625 3.62625 6.6275 2.8783 7.905 2.3274C9.1825 1.7765 10.5475 1.5007 12 1.5C13.4525 1.5 14.8175 1.7758 16.095 2.3274C17.3725 2.879 18.4837 3.62695 19.4287 4.57125C20.3738 5.51625 21.122 6.6275 21.6736 7.905C22.2252 9.1825 22.5007 10.5475 22.5 12C22.5 13.4525 22.2242 14.8175 21.6726 16.095C21.121 17.3725 20.3731 18.4837 19.4287 19.4287C18.4837 20.3738 17.3725 21.122 16.095 21.6736C14.8175 22.2252 13.4525 22.5007 12 22.5ZM12 20.4C14.345 20.4 16.3312 19.5862 17.9587 17.9587C19.5862 16.3312 20.4 14.345 20.4 12C20.4 9.655 19.5862 7.66875 17.9587 6.04125C16.3312 4.41375 14.345 3.6 12 3.6C9.655 3.6 7.66875 4.41375 6.04125 6.04125C4.41375 7.66875 3.6 9.655 3.6 12C3.6 14.345 4.41375 16.3312 6.04125 17.9587C7.66875 19.5862 9.655 20.4 12 20.4Z" fill="#C9C9C9"/>
        </svg>
        <Modal v-if="mobile" :show="showModalTooltipInfo" @close="showModalTooltipInfo = false" :isNowrap="true" :modalClass="'offer-tooltip-modal'">
            <div class="offer-tooltip-info__region" v-if="isShowRegion && offer?.region_game_card">
                <img class="offer-tooltip-info__region-img" :src="offer?.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" alt="Region">
                <div class="offer-tooltip-info__region-divider"></div>
                <RegionOffer :offer="offer" />
                <button @click="showModalTooltipInfo = false" type="button" class="main-card__close-btn close" data-dismiss="modal" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0486 0.334961C14.4949 -0.111352 15.2185 -0.111352 15.6648 0.334961C16.1111 0.781274 16.1111 1.50486 15.6648 1.95117L9.61597 8L15.6648 14.0488C16.1111 14.4951 16.1111 15.2187 15.6648 15.665C15.2185 16.1114 14.4949 16.1114 14.0486 15.665L7.99976 9.61621L1.95093 15.665C1.50461 16.1114 0.78103 16.1114 0.334717 15.665C-0.111596 15.2187 -0.111597 14.4951 0.334717 14.0488L6.38354 8L0.334717 1.95117C-0.111597 1.50486 -0.111597 0.781274 0.334717 0.334961C0.78103 -0.111353 1.50461 -0.111353 1.95093 0.334961L7.99976 6.38379L14.0486 0.334961Z" fill="#C9C9C9"/>
                    </svg>
                </button>
            </div>
            <div v-else class="offer-tooltip-info__region-details">
                <span>{{ $t('Details') }}</span>
                <button @click="showModalTooltipInfo = false" type="button" class="main-card__close-btn close" data-dismiss="modal" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0486 0.334961C14.4949 -0.111352 15.2185 -0.111352 15.6648 0.334961C16.1111 0.781274 16.1111 1.50486 15.6648 1.95117L9.61597 8L15.6648 14.0488C16.1111 14.4951 16.1111 15.2187 15.6648 15.665C15.2185 16.1114 14.4949 16.1114 14.0486 15.665L7.99976 9.61621L1.95093 15.665C1.50461 16.1114 0.78103 16.1114 0.334717 15.665C-0.111596 15.2187 -0.111597 14.4951 0.334717 14.0488L6.38354 8L0.334717 1.95117C-0.111597 1.50486 -0.111597 0.781274 0.334717 0.334961C0.78103 -0.111353 1.50461 -0.111353 1.95093 0.334961L7.99976 6.38379L14.0486 0.334961Z" fill="#C9C9C9"/>
                    </svg>
                </button>
            </div>
            <div class="offer-tooltip-info__body" :class="{online: isOnlineGame}">
                <DynamicAttributes :offer="offer" :isOnlineGame="isOnlineGame"/>

                <div v-if="!isOnlineGame" class="offer-tooltip-info__description" v-html="getOfferDescription()"></div>
            </div>
        </Modal>
        <div v-else class="offer-tooltip-info__wrap" :class="{ 'tablet': tablet }">
            <div class="offer-tooltip-info__region" v-if="isShowRegion && offer?.region_game_card">
                <img class="offer-tooltip-info__region-img" :src="offer?.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" alt="Region">
                <div class="offer-tooltip-info__region-divider"></div>
                <RegionOffer :offer="offer" />
            </div>
            <div class="offer-tooltip-info__body" :class="{online: isOnlineGame}">
                <DynamicAttributes :offer="offer" :isOnlineGame="isOnlineGame"/>

                <div v-if="!isOnlineGame" class="offer-tooltip-info__description" v-html="getOfferDescription()"></div>
            </div>
        </div>
    </div>
    <div class="offer-tooltip-info placeholder" v-else></div>
</template>

<script>
import RegionOffer from './RegionOffer.vue';
import DynamicAttributes from './DynamicAttributes.vue';
import Modal from '../../../../components/Modal.vue';

export default {
    components: {
        RegionOffer,
        DynamicAttributes,
        Modal
    },
    props: {
      offer: {
        type: Object,
        required: true
      },
      isOnlineGame: {
        type: Boolean,
        default: false
      },
      isShowRegion: {
        type: Boolean,
        default: true
      },
      tablet: {
        type: Boolean,
        default: false
      },
      mobile: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
            showModalTooltipInfo: false,
        };
    },
    methods: {
        modalTooltipInfoFun() {
            if (this.mobile) {
                this.showModalTooltipInfo = true;
                return;
            }
        },
        getOfferDescription() {
            if (this.offer?.restricted?.activate_type == 1) {
                return `
                    ${this.$t('To check if a product is activated on your account', { ns: 'product' })}
                    <b>
                        ${this.$t('go to', { ns: 'product' })} ${this.offer.platform.img.alt}
                    </b>
                    ${this.$t('and enter the', { ns: 'product' })}
                    <b>
                        ${this.$t('product name', { ns: 'product' })}
                    </b>
                    ${this.$t('in the search text', { ns: 'product' })}.
                    ${this.$t('If the product', { ns: 'product' })}
                    <b>
                        ${this.$t('cannot be purchased', { ns: 'product' })}
                    </b>
                    ${this.$t('or', { ns: 'product' })}
                    <b>
                        ${this.$t('activated', { ns: 'product' })}
                    </b>,
                    ${this.$t('the key purchased from this seller', { ns: 'product' })}
                    <b>
                        ${this.$t('will not work', { ns: 'product' })}.
                    </b>
                `;
            } else {
                return `
                    ${this.$t('Before buying, be sure to ', { ns: 'product' })}
                    <b>
                        ${this.$t('pay attention to the region and delivery time', { ns: 'product' })}.
                    </b>
                    ${this.$t('In case of buying products from the wrong region', { ns: 'product' })},
                    <b>
                        ${this.$t('the company and the seller are not responsible', { ns: 'product' })}.
                    </b>
                `;
            }
        },
    }
};
</script>

<style lang="scss">
.offer-tooltip-modal{
        width: 100%;
        border-radius: 16px 16px 0 0 !important;
        .close{
            display: flex;
            align-items: center;
            justify-content: center;
            top: 22px;
            right: 20px;
            opacity: 1;
        }
        .btn{

        }
        .offer-tooltip-info__region{
            padding-right: 50px;
        }
        .offer-tooltip-info__region-details{
            padding: 15px;
            background-color: #F5F5F5;
            .close{
                top: 20px;
            }
            span{
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #505050;
            }
        }
        .offer-tooltip-info__body{
            &.online{
                @media only screen and (max-width: 767px) {
                    border-radius: 0 !important;
                    .flex-row.full{
                        margin-top: 0;
                    }
                }
            }
            .atribute-title{
                display: none;
            }
            .flex-row{
                &.id{
                    margin-top: 5px;
                    justify-content: space-between;
                }
                &.align-stretch{
                    margin-top: 0;
                    flex-direction: column;
                    .flex-row{
                        width: 100%;
                        justify-content: space-between;
                        .flex-item{
                            text-align: right;
                        }
                    }
                    .divider{
                        display: none;
                    }
                }
                &.full{
                    margin-top: 5px;
                    width: 100%;
                    gap: 0;
                    .flex-column.gap-20{
                        width: 50%;
                        .delivery_block{
                            width: 100%;
                            max-width: none;
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .offer-tooltip-info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        &.placeholder{
            margin-left: 6px;
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 8px;
            pointer-events: none;
        }
        &__icon-svg{
            cursor: pointer;
            path{
                transition: 0.4s;
            }
            @media only screen and (max-width: 991px) {
                width: 17px;
                height: 17px;
            }
        }
        &__wrap{
            position: absolute;
            top: 30px;
            right: 0;
            box-shadow: 0px 0px 15px 0px #00000026;
            border-radius: 16px;
            opacity: 0;
            transition: 0.4s;
            pointer-events: none;
            z-index: 10;
            &.tablet{
                left: -30px;
                right: auto;
            }
            &::before{
                z-index: 9;
                position: absolute;
                height: calc(100% + 80px);
                width: 100%;
                top: -40px;
                left: 0;
                background-color: transparent;
                content: '';
            }
        }
        &:hover{
            //@media only screen and (min-width: 768px) {
                .offer-tooltip-info__icon-svg{
                    path{
                        fill: #4E8AFF;
                    }
                }
                .offer-tooltip-info__wrap{
                    opacity: 1;
                    pointer-events: auto;
                }
            //}
        }
        &__region{
            padding: 15px;
            background-color: #F6F5FA;
            border-radius: 16px 16px 0 0;
            gap: 15px;
            display: flex;
            align-items: center;
            z-index: 10;
            position: relative;
            &-img{
                width: 30px;
                height: 30px;
                max-width: 30px;
                border-radius: 50%;
                border: 1px solid #E5E5E5;
            }
            &-divider{
                height: 30px;
                width: 1px;
                background-color: #E5E5E5;
            }
        }
        &__body{
            padding: 12px 15px;
            background-color: #fff;
            border-radius: 0 0 16px 16px;
            z-index: 10;
            position: relative;
            &.online{
                border-radius: 16px;
            }
        }
        &__description{
            font-family: "Avenir-Next";
            font-weight: 400;
            font-style: Regular;
            font-size: 14px;
            line-height: 140%;
            letter-spacing: 0px;
            color: #9D9D9D;
            width: 100%;
            padding-top: 15px;
            border-top: 1px solid #E5E5E5;
            margin-top: 15px;
            :deep(b){
                font-family: "Avenir-Next-DemiBold", sans-serif;
            }
        }
    }
</style>